import React, { Component } from "react";
import { TEXTS } from "../constants/texts";

class StopCodeScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timer: 7,
      activeTimer: false,
      link: "",
      message: "",
    };
    // rozparsovani www a zpravy
    let msg = (this.state.message = this.props.message);
    if (
      msg.startsWith("www.") &&
      msg.indexOf("|") > 0 &&
      this.props.stopcode >= 5
    ) {
      this.state.link = msg.substring(0, msg.indexOf("|"));
      this.state.message = msg.substring(msg.indexOf("|") + 1);
    }

    this.handleContinue = this.handleContinue.bind(this);
    this.handleLeave = this.handleLeave.bind(this);
    this.handleAgain = this.handleAgain.bind(this);

    let stopCode = parseInt(this.props.stopcode);

    if (stopCode === 1) {
      this.runTimer();
    }
  }

  handleContinue() {
    this.props.btnContinue();
  }

  handleLeave() {
    this.props.btnLeave();
  }

  handleAgain() {
    console.log("STOP CODE: " + this.props.stopcode);
    if (this.props.stopcode === 5) {
      window.location.reload();
      return false;
    }

    if (this.props.attempt >= 3) {
      window.location.reload();
      return false;
    }
    console.log("attempt < 3 - we go again with nickname and access code");
    this.props.resetDialog();
  }

  runTimer() {
    setTimeout(() => {
      let newValue = this.state.timer - 1;
      this.setState({ timer: newValue });
      if (newValue < 1) {
        this.handleContinue();
      } else {
        this.runTimer();
      }
    }, 1000);
  }

  render() {
    return (
      <div className="App stopcodeScreen">
        <div className="stopcode">
          <header className="message">{this.state.message}</header>

          {this.controls()}

          {this.finalactions()}
        </div>
      </div>
    );
  }

  finalactions() {
    if (this.props.stopcode >= 5) {
      // zobrazi bud odkaz "DETAIL" nebo tlacitko "AGAIN"
      if (this.state.link) {
        let link = "https://" + this.state.link;
        return (
          <div className="controls">
            <div className={"btn-again"}>
              <a href={link} style={{ color: "#ffffff" }}>
                {TEXTS.buttons.detail}
              </a>
            </div>
          </div>
        );
      } else {
        return (
          <div className="controls">
            <div className={"btn btn-again"}>
              <button onClick={this.handleAgain}>{TEXTS.buttons.again}</button>
            </div>
          </div>
        );
      }
    }
    return "";
  }
  controls() {
    let stopCode = parseInt(this.props.stopcode);

    if (stopCode === 1) {
      // set timeout.. a pri nule  this.handleContinue
      return (
        <div className="controls">
          <div class={"btn-timer bg-color-dark"}>
            <div className={"timer"}>{this.state.timer}</div>
          </div>
        </div>
      );
    }
    if (stopCode === 2) {
      return (
        <div className="controls">
          <button className="btn btn-continue" onClick={this.handleContinue}>
            {TEXTS.buttons.continue}
          </button>
        </div>
      );
    }
    if (stopCode === 3) {
      return (
        <div className="controls">
          <button
            className="btn btn-continue mb-2 mr-2"
            onClick={this.handleContinue}
          >
            {TEXTS.buttons.continue}
          </button>
          <button className="btn btn-leave" onClick={this.handleLeave}>
            {TEXTS.buttons.close}
          </button>
          <div className="block-dark" />
        </div>
      );
    }
    if (stopCode === 4) {
      return (
        <div className="controls">
          <div className="btn btn-leave">
            <button className="leave" onClick={this.handleLeave}>
              {TEXTS.buttons.close}
            </button>
          </div>
        </div>
      );
    }
  }
}

export default StopCodeScreen;
